// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brands-container {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
}

.brand-name {
  margin-right: 15px;
  margin-left: 5px;
  display: inline-flex; /* Cambiar a inline-flex para que sea como texto en línea */
  align-items: baseline; /* Asegura que el subtítulo esté alineado con el título */
  justify-content: flex-start;
  text-decoration: none;
  color: #000000;
  font-family: "CreatoDisplay", sans-serif;
  font-weight: 800;
  padding-left: 0;
  margin-left: 0;
  transition: color 0.3s ease-in-out;
  font-size: 30px;
  z-index: 999;
  cursor: pointer;
  flex-wrap: nowrap; /* Asegura que no se divida en múltiples líneas */
}

.brand-name:hover {
  color: #d40606; /* Cambiar el color de hover a rojo o cualquier otro efecto deseado */
}

.small-italic {
  font-family: "EB Garamond", serif;
  font-size: 16px;
  font-style: italic;
  color: #000000;
  font-weight: 100;
  margin-left: 5px; /* Espacio pequeño entre el título y subtítulo */
  white-space: nowrap; /* Evita que el subtítulo se divida en líneas separadas */
}

.brand-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
  z-index: 12;
  pointer-events: none;
  animation: fadeIn 1s forwards; /* Solo animación de entrada inicialmente */
}

.brand-image.show {
  z-index: 13; /* Mueve la imagen al frente cuando se muestra */
}

.brand-image.hide {
  animation: fadeOut 1s forwards; /* Animación de salida */
}

.brand-image img {
  max-width: 90%;
  max-height: 90%;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 200px;
  position: relative;
}

.logo-container img {
  max-width: 50%; 
  max-height: 50%; 
  transition: filter 0.3s ease-in-out; /* Transición suave para el efecto */
  cursor: pointer; /* Cambia el cursor al pasar sobre el logo */
}

.logo-container:hover .hover-text {
  opacity: 1; 
  visibility: visible; 
  z-index: 13; /* Asegura que el texto esté por encima del logo */
}

.hover-text {
  position: fixed; 
  top: 0; 
  left: 0; 
  width: 100vw; 
  height: 100vh; 
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8); 
  color: #fff;
  opacity: 0; 
  visibility: hidden; 
  transition: opacity 0.3s ease, visibility 0.3s ease; 
  pointer-events: none;
  padding: 200px; /* Da espacio alrededor del contenedor */
  box-sizing: border-box; /* Asegura que el padding no sobresalga */
}

.hover-text-inner {
  max-width: 80vw; /* Limita el ancho del contenido al 80% del viewport */
  margin: 0 auto; /* Centra horizontalmente el contenido */
  text-align: center; /* Centra el texto dentro del contenedor */
  line-height: 1.5; /* Mejora la legibilidad */
}




@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}


@media (max-width: 768px) {
  .brand-name {
    font-size: 2rem; /* Ajusta el tamaño en pantallas móviles */
    white-space: normal; /* Permite que el texto se divida si es demasiado largo en pantallas pequeñas */
    line-height: 1;
  }

  .small-italic {
    font-size: 0.8rem; /* Ajusta el tamaño del subtítulo en móviles */
    white-space: normal; /* Permite que el subtítulo se ajuste si es necesario */
  }
  
  .brands-container {
    margin-bottom: 100px;
    display: flex;
    flex-direction: column; /* Apilar marcas en columnas */
    align-items: flex-start; /* Alinear las marcas al inicio */
  }

  .logo-container {
    display: none; /* Ocultar en móviles si es necesario */
  }
  .brand-name:hover {
    color: #000000;
  }
}

  

`, "",{"version":3,"sources":["webpack://./src/styles/Brands.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB,EAAE,2DAA2D;EACjF,qBAAqB,EAAE,yDAAyD;EAChF,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB,EAAE,iDAAiD;AACtE;;AAEA;EACE,cAAc,EAAE,qEAAqE;AACvF;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB,EAAE,gDAAgD;EAClE,mBAAmB,EAAE,yDAAyD;AAChF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,6BAA6B,EAAE,2CAA2C;AAC5E;;AAEA;EACE,WAAW,EAAE,gDAAgD;AAC/D;;AAEA;EACE,8BAA8B,EAAE,wBAAwB;AAC1D;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC,EAAE,oCAAoC;EACzE,eAAe,EAAE,4CAA4C;AAC/D;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,WAAW,EAAE,kDAAkD;AACjE;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mDAAmD;EACnD,oBAAoB;EACpB,cAAc,EAAE,wCAAwC;EACxD,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;EACE,eAAe,EAAE,sDAAsD;EACvE,cAAc,EAAE,wCAAwC;EACxD,kBAAkB,EAAE,0CAA0C;EAC9D,gBAAgB,EAAE,0BAA0B;AAC9C;;;;;AAKA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,eAAe,EAAE,0CAA0C;IAC3D,mBAAmB,EAAE,+EAA+E;IACpG,cAAc;EAChB;;EAEA;IACE,iBAAiB,EAAE,8CAA8C;IACjE,mBAAmB,EAAE,uDAAuD;EAC9E;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,sBAAsB,EAAE,8BAA8B;IACtD,uBAAuB,EAAE,iCAAiC;EAC5D;;EAEA;IACE,aAAa,EAAE,uCAAuC;EACxD;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".brands-container {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px;\n  max-width: 100%;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.brand-name {\n  margin-right: 15px;\n  margin-left: 5px;\n  display: inline-flex; /* Cambiar a inline-flex para que sea como texto en línea */\n  align-items: baseline; /* Asegura que el subtítulo esté alineado con el título */\n  justify-content: flex-start;\n  text-decoration: none;\n  color: #000000;\n  font-family: \"CreatoDisplay\", sans-serif;\n  font-weight: 800;\n  padding-left: 0;\n  margin-left: 0;\n  transition: color 0.3s ease-in-out;\n  font-size: 30px;\n  z-index: 999;\n  cursor: pointer;\n  flex-wrap: nowrap; /* Asegura que no se divida en múltiples líneas */\n}\n\n.brand-name:hover {\n  color: #d40606; /* Cambiar el color de hover a rojo o cualquier otro efecto deseado */\n}\n\n.small-italic {\n  font-family: \"EB Garamond\", serif;\n  font-size: 16px;\n  font-style: italic;\n  color: #000000;\n  font-weight: 100;\n  margin-left: 5px; /* Espacio pequeño entre el título y subtítulo */\n  white-space: nowrap; /* Evita que el subtítulo se divida en líneas separadas */\n}\n\n.brand-image {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 12;\n  pointer-events: none;\n  animation: fadeIn 1s forwards; /* Solo animación de entrada inicialmente */\n}\n\n.brand-image.show {\n  z-index: 13; /* Mueve la imagen al frente cuando se muestra */\n}\n\n.brand-image.hide {\n  animation: fadeOut 1s forwards; /* Animación de salida */\n}\n\n.brand-image img {\n  max-width: 90%;\n  max-height: 90%;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  margin-top: 200px;\n  position: relative;\n}\n\n.logo-container img {\n  max-width: 50%; \n  max-height: 50%; \n  transition: filter 0.3s ease-in-out; /* Transición suave para el efecto */\n  cursor: pointer; /* Cambia el cursor al pasar sobre el logo */\n}\n\n.logo-container:hover .hover-text {\n  opacity: 1; \n  visibility: visible; \n  z-index: 13; /* Asegura que el texto esté por encima del logo */\n}\n\n.hover-text {\n  position: fixed; \n  top: 0; \n  left: 0; \n  width: 100vw; \n  height: 100vh; \n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.8); \n  color: #fff;\n  opacity: 0; \n  visibility: hidden; \n  transition: opacity 0.3s ease, visibility 0.3s ease; \n  pointer-events: none;\n  padding: 200px; /* Da espacio alrededor del contenedor */\n  box-sizing: border-box; /* Asegura que el padding no sobresalga */\n}\n\n.hover-text-inner {\n  max-width: 80vw; /* Limita el ancho del contenido al 80% del viewport */\n  margin: 0 auto; /* Centra horizontalmente el contenido */\n  text-align: center; /* Centra el texto dentro del contenedor */\n  line-height: 1.5; /* Mejora la legibilidad */\n}\n\n\n\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .brand-name {\n    font-size: 2rem; /* Ajusta el tamaño en pantallas móviles */\n    white-space: normal; /* Permite que el texto se divida si es demasiado largo en pantallas pequeñas */\n    line-height: 1;\n  }\n\n  .small-italic {\n    font-size: 0.8rem; /* Ajusta el tamaño del subtítulo en móviles */\n    white-space: normal; /* Permite que el subtítulo se ajuste si es necesario */\n  }\n  \n  .brands-container {\n    margin-bottom: 100px;\n    display: flex;\n    flex-direction: column; /* Apilar marcas en columnas */\n    align-items: flex-start; /* Alinear las marcas al inicio */\n  }\n\n  .logo-container {\n    display: none; /* Ocultar en móviles si es necesario */\n  }\n  .brand-name:hover {\n    color: #000000;\n  }\n}\n\n  \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
